import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { TopLevelErrorBoundary } from '@monorepo/shared/componentsV2/errorDisplays/TopLevelErrorBoundary';
import { ModalWizardNavigationProvider } from '@monorepo/shared/componentsV2/modalWizard/modalWizardNavigationContext';
import { ModalProvider } from '@monorepo/shared/contexts/ModalContextV2';
import { ReactQueryConfig } from '@monorepo/shared/contexts/ReactQueryConfig';
import { SubnavProvider } from '@monorepo/shared/contexts/SubnavContext';
import { ToastProvider } from '@monorepo/shared/contexts/ToastContext';
import { DefaultThemeProvider } from '@monorepo/shared/themes/DefaultThemeProvider';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import { WebSocketSetup } from '../contexts/pushMessages/WebSocketSetup';

interface ProvidersProps {
  children: React.ReactNode;
}

// TODO: Transition to using createBrowserRouter instead of BrowserRouter
// https://reactrouter.com/6.30.1/routers/picking-a-router#using-v64-data-apis

export function Providers({ children }: ProvidersProps) {
  return (
    <ReactQueryConfig>
      <DefaultThemeProvider>
        <HelmetProvider>
          <ToastProvider>
            <TopLevelErrorBoundary>
              <AuthProvider>
                <WebSocketSetup>
                  <SubnavProvider>
                    <ModalProvider>
                      <ModalWizardNavigationProvider>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <BrowserRouter>{children}</BrowserRouter>
                        </MuiPickersUtilsProvider>
                      </ModalWizardNavigationProvider>
                    </ModalProvider>
                  </SubnavProvider>
                </WebSocketSetup>
              </AuthProvider>
            </TopLevelErrorBoundary>
          </ToastProvider>
        </HelmetProvider>
      </DefaultThemeProvider>
    </ReactQueryConfig>
  );
}
